<input pInputText
  id="text"
  #text="ngModel"
  type="text"
  [required]="column.validation?.isRequired === true"
  [maxlength]="column.validation?.maxLength || null"
  [(ngModel)]="record[column.field]" />

  @if (text.invalid && (text.dirty || text.touched)) {
    <div
      class="alert">
      @if (text.errors?.['required']) {
        <div>
          Required.
        </div>
      }
      @if (text.errors?.['minlength']) {
        <div>
          Must be at least 4 characters long.
        </div>
      }
      @if (text.errors?.['maxlength'] && column.validation?.maxLength) {
        <div>
          Max {{ column.validation?.maxLength }} characters long.
        </div>
      }
    </div>
  }
